export default {"src":"/_next/static/media/Icon_Desde.6a589533.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};